import { useRouter } from "next/router";
import { ArticleJsonLd, NextSeo } from "next-seo";

import { PostFragment } from "../interfaces";
import baseUrl from "../lib/baseUrl";
import LogoWithBackground from "../public/logo_with_background.png";
import BlurImage from "./BlurImage";
import RichTextRenderer from "./RichTextRenderer";

type Props = PostFragment;

const Post = (props: Props) => {
  const router = useRouter();

  return (
    <>
      <NextSeo
        title={props.seo.title || props.title || ""}
        description={props.seo.description || props.description || ""}
        noindex={props.seo.noIndex}
        openGraph={{
          title: props.seo.title || props.title,
          description: props.seo.description || props.description || "",
          url: baseUrl + router.pathname,
          type: "article",
          article: {
            publishedTime: props.publishedAt,
            modifiedTime: props.updatedAt,
            section: props.categories[0].name,
            tags: props.tags,
          },
          images: [
            {
              url: props.image?.url || "/logo_with_background.png",
              alt: props.imageAlt || props.title,
            },
          ],
        }}
      />
      <ArticleJsonLd
        url={baseUrl + router.pathname}
        title={props.seo.title || props.title}
        description={props.seo.description || props.description || ""}
        images={[props.image?.url || "/logo_with_background.png"]}
        datePublished={props.publishedAt}
        dateModified={props.updatedAt}
        publisherName="Welfare Abroad"
        publisherLogo={baseUrl + "/logo.png"}
        authorName={[
          {
            "@type": "Organization",
            name: "Welfare Abroad",
          },
        ]}
      />
      <div className="bg-white">
        <div className="px-4 py-16 mx-auto max-w-7xl sm:py-24 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="mt-1 text-4xl font-extrabold text-gray-900 sm:text-5xl sm:tracking-tight lg:text-6xl">
              {props.title}
            </h1>
            <p className="max-w-xl mx-auto mt-5 text-xl text-gray-500">
              {props.description}
            </p>
          </div>
        </div>
      </div>
      <div className="relative mx-auto max-w-7xl">
        <div className="aspect-w-16 aspect-h-9">
          <BlurImage
            src={props.image?.url || LogoWithBackground}
            alt={props.imageAlt || props.title}
            className="object-cover"
            fill
          />
        </div>
      </div>
      <div className="relative py-16 overflow-hidden bg-white">
        <div className="relative px-4 sm:px-6 lg:px-8">
          <div className="mx-auto mt-6 prose prose-lg text-gray-500 prose-green">
            <RichTextRenderer content={props.content?.json} />
          </div>
        </div>
      </div>
    </>
  );
};

export default Post;
